import React, { useLayoutEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import PractitionerMediaPreviewPlayer from './PractitionerMediaPreviewPlayer';

interface PractitionerMediaPreviewPortalProps {
  portalNode: HTMLDivElement | null;
  className?: string;
}

interface PractitionerMediaPreviewHostProps {
  portalNode: HTMLDivElement | null;
  isActive: boolean;
  isOverlay?: boolean;
}

export const PractitionerMediaPreviewPortal = ({ portalNode, className }: PractitionerMediaPreviewPortalProps) => {
  if (!portalNode) {
    return null;
  }

  return createPortal(<PractitionerMediaPreviewPlayer className={className} />, portalNode);
};

export const PractitionerMediaPreviewHost = ({
  portalNode,
  isActive,
  isOverlay = false,
}: PractitionerMediaPreviewHostProps) => {
  const hostRef = useRef<HTMLDivElement | null>(null);

  useLayoutEffect(() => {
    const hostElement = hostRef.current;
    if (!portalNode || !isActive || !hostElement) {
      return;
    }

    hostElement.appendChild(portalNode);
  }, [isActive, portalNode]);

  return (
    <div
      ref={hostRef}
      style={{
        display: isActive ? 'block' : 'none',
        position: isOverlay ? 'absolute' : 'relative',
        inset: isOverlay ? 0 : undefined,
        width: '100%',
        height: '100%',
      }}
    />
  );
};
